import { fields } from ".";
import { useEffect, useRef } from "react";
import { change, reduxForm, reset } from "redux-form";
import Button from "components/atoms/Button";
import ReduxFormComponent from "components/atoms/ReduxFormComponent";
import { Divider, Grid, Stack, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { availabilityActions } from "redux/slices/availability";

const FORM = "AddAvailabilityForm";

function AddAvailabilityForm({ handleSubmit, submitting }: any) {
	const dispatch = useAppDispatch();
	const panel = useRef<HTMLDivElement>(null);
	// The list's Edit button fills this same form, so the panel has to say which
	// mode it is in — otherwise the change happens off-screen above the list.
	const availability = useAppSelector(
		(state) => state.availability.availability
	);
	const isEditing = Boolean(availability);

	useEffect(() => {
		if (!isEditing) return;
		const reduceMotion = window.matchMedia?.(
			"(prefers-reduced-motion: reduce)"
		).matches;
		panel.current?.scrollIntoView({
			block: "start",
			behavior: reduceMotion ? "auto" : "smooth",
		});
	}, [isEditing]);

	const cancelEdit = () => {
		dispatch(availabilityActions.setAvailability(null));
		dispatch(reset(FORM));
		// After the reset, not before: reset restores the pickers to "", and an
		// empty string is an invalid date the picker keeps its old text for. Only
		// an explicit null clears the input.
		dispatch(change(FORM, "start_date", { date: null, error: false }));
		dispatch(change(FORM, "end_date", { date: null, error: false }));
	};

	return (
		<div ref={panel}>
			<form onSubmit={handleSubmit}>
				<Stack
					direction="row"
					spacing={2}
					alignItems="center"
					justifyContent="space-between"
				>
					<Typography variant="h6" sx={{ fontWeight: 700 }}>
						{isEditing ? "Edit Availability" : "Add Availability"}
					</Typography>
					{isEditing && (
						<Button variant="text" onClick={cancelEdit} disabled={submitting}>
							Cancel
						</Button>
					)}
				</Stack>
				<Divider sx={{ mt: 2, mb: 3 }} />

				{/* Every field and the action on one row. */}
				<Grid container spacing={2} alignItems="center">
					{fields.map(({ cellProps, ...field }: any) => (
						<Grid item key={field.name} xs={12} sm={6} md={2.5}>
							<ReduxFormComponent {...field} />
						</Grid>
					))}
					<Grid item xs={12} md={2}>
						<Button
							fullWidth
							variant="contained"
							type="submit"
							disabled={submitting}
							sx={{ height: "48px" }}
						>
							{isEditing ? "Edit" : "Add"}
						</Button>
					</Grid>
				</Grid>
			</form>
		</div>
	);
}
export default reduxForm({ form: FORM })(AddAvailabilityForm);
